"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawStateService = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const core_shared_1 = require("@ikegps/core-shared");
const page_state_1 = require("../state/page.state");
const index_1 = require("./index");
const log_service_1 = require("./log.service");
class DrawStateService {
    constructor(log) {
        this.log = log;
        this.__priority = 100;
        this._drawCacheKeys = [];
        this._drawCacheMap = {};
    }
    getIkeDraw(collection, captureId) {
        if (page_state_1.CurrentState.CollectionEdit.collectionRevision === collection.revision) {
            return page_state_1.CurrentState.CollectionEdit.getIkeDraw(captureId);
        }
        const drawKey = `${collection.revision}:${captureId}`;
        const existing = this._drawCacheMap[drawKey];
        if (existing) {
            return existing;
        }
        const drawState = this.createIkeDraw(collection, captureId);
        this._drawCacheKeys.push(drawKey);
        this._drawCacheMap[drawKey] = drawState;
        // This draw caching limit is arbitrary, It will limit the number of captures
        // that can be rendered at one time in the report..
        if (this._drawCacheKeys.length > 1024) {
            const oldDraws = this._drawCacheKeys.splice(0, 10);
            for (const oldKey of oldDraws) {
                delete this._drawCacheMap[oldKey];
            }
        }
        return drawState;
    }
    createIkeDraw(collection, captureId) {
        const capture = collection.state.getCapture(captureId);
        if (capture == null) {
            index_1.Services.Log.Logger.error({ collectionId: collection.id, captureId }, 'Missing capture');
            return null;
        }
        const window = index_1.Services.Window.window;
        return new core_shared_1.IkeDraw({
            log: this.log,
            collection,
            capture,
            window,
            captureMaskFetcher: maskFetcher,
            onStartHOASession: () => {
                index_1.Services.Analytics.trackTiming(core_api_1.TimingEventType.HOA, core_api_1.TimingEventAction.ENTER, collection.id, new Date());
            }
        });
    }
}
exports.DrawStateService = DrawStateService;
const maskFetcher = (collectionId, captureId) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const preSignedMask = yield index_1.Services.Department.rest.Capture.getMask({ collectionId, captureId });
    if (preSignedMask == null) {
        log_service_1.Logger.error({ collectionId, captureId }, 'Mask presigned URL was empty');
        return '';
    }
    const response = yield fetch(preSignedMask.presignedUrl, { headers: { Accept: 'image/svg+xml' } });
    if (!response.ok) {
        log_service_1.Logger.error({ response, url: preSignedMask.presignedUrl }, 'Presigned URL returned bad response');
        return '';
    }
    log_service_1.Logger.debug({ collectionId, captureId, url: preSignedMask.presignedUrl }, 'Masks fetched');
    return yield response.text();
});
//# sourceMappingURL=draw.state.service.js.map